export default {
    colors: {
        'green': '#64dd17',
        'red': '#ff4e58',
        'blue': '#42a5f5',
        'brown': '#d0a264',
        'pink': '#ff4081'
    }
}
